<template>
  <div class="build-city">
    <div class="wrapper">
      <img
        v-for="(filename, index) in images"
        :key="index"
        :src="require(`@/assets/images/build-city/${filename}.svg`)"
        :class="filename"
        alt=""
        draggable="false"
      />
    </div>
  </div>
</template>

<script>
import { TimelineMax } from 'gsap'

export default {
  name: 'BuildCity',
  data () {
    return {
      images: ['f-blonde', 'f-blue', 'f-pink', 'f-red', 'f-yellow', 'horse', 'house-blue', 'house-red', 'm-black', 'm-blue', 'm-capblue', 'm-monocle', 'm-pink', 'm-suitblack', 'm-suitblue', 'm-suitpink', 'm-suitred', 'tower', 'stembus']
    }
  },
  mounted () {
    const scene = this.$scrollmagic.scene({
      triggerElement: '#build-city-trigger',
      triggerHook: 1,
      duration: '100%',
      offset: 200
    })

    const timeline = new TimelineMax()
      .fromTo('.f-blonde', 1, {
        x: -500,
        y: -500
      }, { x: 0, y: 0, autoAlpha: 1 }, 0)
      .fromTo('.f-blue', 1, {
        x: -400,
        y: -600
      }, { x: 0, y: 0, autoAlpha: 1 }, 0)
      .fromTo('.f-pink', 1, {
        x: -100,
        y: -500
      }, { x: 0, y: 0, autoAlpha: 1 }, 0)
      .fromTo('.f-red', 1, {
        x: 200,
        y: -400
      }, { x: 0, y: 0, autoAlpha: 1 }, 0)
      .fromTo('.f-yellow', 1, {
        x: 400,
        y: -500
      }, { x: 0, y: 0, autoAlpha: 1 }, 0)
      .fromTo('.horse', 1, {
        x: -500,
        y: 300
      }, { x: 0, y: 0, autoAlpha: 1 }, 0)
      .fromTo('.house-blue', 1, {
        x: -250,
        y: -400
      }, { x: 0, y: 0, autoAlpha: 1 }, 0)
      .fromTo('.house-red', 1, {
        x: 300,
        y: -200
      }, { x: 0, y: 0, autoAlpha: 1 }, 0)
      .fromTo('.m-black', 1, {
        x: 100,
        y: -300
      }, { x: 0, y: 0, autoAlpha: 1 }, 0)
      .fromTo('.m-blue', 1, {
        x: -50,
        y: -400
      }, { x: 0, y: 0, autoAlpha: 1 }, 0)
      .fromTo('.m-capblue', 1, {
        x: -400,
        y: 50
      }, { x: 0, y: 0, autoAlpha: 1 }, 0)
      .fromTo('.m-monocle', 1, {
        x: 50,
        y: -300
      }, { x: 0, y: 0, autoAlpha: 1 }, 0)
      .fromTo('.m-pink', 1, {
        x: -200,
        y: 200
      }, { x: 0, y: 0, autoAlpha: 1 }, 0)
      .fromTo('.m-suitblack', 1, {
        x: 100,
        y: 300
      }, { x: 0, y: 0, autoAlpha: 1 }, 0)
      .fromTo('.m-suitpink', 1, {
        x: 300,
        y: 300
      }, { x: 0, y: 0, autoAlpha: 1 }, 0)
      .fromTo('.m-suitred', 1, {
        x: 400,
        y: 300
      }, { x: 0, y: 0, autoAlpha: 1 }, 0)
      .fromTo('.m-suitblue', 1, {
        x: -300,
        y: 300
      }, { x: 0, y: 0, autoAlpha: 1 }, 0)
      .fromTo('.tower', 1, {
        x: 200,
        y: 300
      }, { x: 0, y: 0, autoAlpha: 1 }, 0)

    this.$scrollmagic.addScene(scene.setTween(timeline))
  }
}
</script>

<style lang="scss" scoped>
.build-city {
  position: relative;
  height: 350px;
  z-index: 1;
  margin-top: 50px;
  margin-bottom: 75px;

  @media (min-width: 768px) {
    margin-bottom: 100px;
  }
}

.wrapper {
  position: absolute;
  width: 400px;
  left: 50%;
  transform: translateX(-50%);

  > * {
    position: absolute;
    opacity: 0;
  }
}

.stembus {
  left: 135px;
  top: 95px;
  width: 151px;
  height: 114px;
  opacity: 1;
}

.f-blue {
  left: 80px;
  top: 98px;
}

.f-pink {
  left: 106px;
  top: 98px;
}

.f-yellow {
  left: 295px;
  top: 103px;
}

.f-blue,
.f-pink,
.f-yellow {
  width: 23px;
}

.m-monocle {
  left: 243px;
  top: 26px;
}

.m-suitred {
  left: 314px;
  top: 191px;
}

.m-suitblue {
  left: 35px;
  top: 150px;
}

.m-suitblack {
  left: 150px;
  top: 197px;
}

.m-monocle,
.m-suitred,
.m-suitblue,
.m-suitblack {
  width: 19px;
}

.m-blue {
  left: 169px;
  top: 26px;
}

.m-black {
  left: 302px;
  top: 13px;
}

.m-suitpink {
  left: 368px;
  top: 91px;
}

.m-blue,
.m-black,
.m-suitpink {
  width: 21px;
}

.f-red {
  left: 376px;
  top: 230px;
}

.f-blonde {
  left: 90px;
  top: 221px;
}

.f-red,
.f-blonde {
  width: 20px;
}

.m-pink {
  width: 26px;
  left: 111px;
  top: 256px;
}

.m-capblue {
  width: 16px;
  left: 18px;
  top: 37px;
}

.horse {
  width: 64px;
  top: 236px;
  left: 0;
}

.tower {
  left: 230px;
  top: 189px;
}

.house-red {
  left: 350px;
  top: 32px;
}

.house-blue {
  left: 73px;
  top: 0;
}

.tower,
.house-red,
.house-blue {
  width: 46px;
}
</style>
